img{max-width:600px;max-height:700px;min-width:100px;min-height:100px}.popover-with-header{padding:10px}
/*# sourceMappingURL=input-summary.component.css.map */
